export default {
    resetState({commit}) {
        commit('resetStateMutation');
    },
    openForm({commit}) {
        commit('setFormOpenEprofileAllergia');
    },
    closeForm({commit}) {
        commit('setFormCloseEprofileAllergia');
    },
    modifyAgensInputType({commit}, eesztId) {
        commit('modifyAgensInputType', eesztId);
    }
}
